export default {
    partnerId: {
        presence: true,
        type: "string",
    },
};
